import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
// import EditSortDialog from "@/modules/newCommunity/pages/operationTools/pages/questionnaire/components/EditSortDialog.vue";
import { EnumCommunityType } from "@modules/newCommunity/pages/operationTools/api/questionnaire";
let patientName = class patientName extends Vue {
  constructor() {
    super(...arguments);
    this.loading = false;
    // private catalogList: any[] = [];
    // private editSortDialogKey = Math.random();
    this.postForm = {
      title: "请填写患者姓名首字母缩写",
      required: "1",
      coontent: "",
      itemScore: 0,
      rightText: "",
      scoreRule: "",
      catalogIds: [],
      whetherJoinQuestionBank: false,
      jsonConfig: {
        showIndex: true,
        inputForm: "NONE",
        inputNumberMin: "",
        inputNumberMax: "",
        inputNumberPrecision: "",
        inputMin: "",
        inputMax: ""
      }
    };
    this.rules = {
      title: [{
        required: true,
        message: "请输入标题",
        trigger: "blur"
      }],
      required: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }],
      coontent: [{
        required: false,
        type: "string",
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get communityType() {
    return this.$route.path.includes("newCommunity") ? EnumCommunityType.DOCTOR : EnumCommunityType.PATIENT;
  }
  get basicParams() {
    return {
      businessType: this.questionnaireType,
      communityType: this.communityType
    };
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  // remoteMethod(query?: any) {
  //   this.loading = true;
  //   getCatalog({ ...this.basicParams, name: query, pageSize: 50, pageNum: 1 })
  //     .then((res: any) => {
  //       this.catalogList = res.rows || [];
  //     })
  //     .finally(() => (this.loading = false));
  // }
  // catalogFocus() {
  //   if (this.catalogList.length === 0) {
  //     this.remoteMethod();
  //   }
  // }
  openSortDialog() {
    this.$refs.editSortDialog.onShow({
      isBusinessTypeDisable: true,
      formData: {
        businessType: this.questionnaireType
      }
    });
  }
  async validate() {
    return await this.getFormInstance().validate().catch(err => {
      return err;
    });
  }
  resetFields() {
    this.getFormInstance().resetFields();
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], patientName.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], patientName.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], patientName.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], patientName.prototype, "watchPostForm", null);
patientName = __decorate([Component({
  name: "patientName",
  components: {
    questionSettingTemplate
  }
})], patientName);
export default patientName;